if (!customElements.get('launch-video-spotlight')) {
  customElements.define(
    'launch-video-spotlight',
    class LaunchVideoSpotlight extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.modal = this.querySelector('[data-launch-video-modal]');
        this.videoMedia = this.modal?.querySelector('video-media');

        if (!this.modal || !this.videoMedia) return;

        this.modal.addEventListener('modal:afterShow', () => {
          requestAnimationFrame(() => this.videoMedia?.play());
        }, { signal: this.abortController.signal });

        this.modal.addEventListener('modal:afterHide', () => {
          this.videoMedia?.pause();
        }, { signal: this.abortController.signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }
    }
  );
}
